import { PROTECTED_ROUTES, registrarApplicantPath } from "@/navigation/routes";

export interface AdmissionsOrigin {
  origin: "admissions";
  applicantId: string;
  studentId: string;
}

export interface PersonOrigin {
  origin: "person";
  personId: string;
  studentId: string;
}

export function personOriginFromSearch(search: URLSearchParams): PersonOrigin | null {
  const personId = search.get("person");
  const studentId = search.get("student");
  const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return search.get("origin") === "person" && personId && studentId && uuid.test(personId) && uuid.test(studentId)
    ? { origin: "person", personId, studentId } : null;
}

export function personRecordHref(origin: PersonOrigin): string {
  return `/admin/people?${new URLSearchParams({ visit: `person:${origin.personId}` })}`;
}

export function personCourseSetupHref(studentId: string, personId: string): string {
  return `${PROTECTED_ROUTES.admin.courses}?${new URLSearchParams({ student: studentId, origin: "person", person: personId })}`;
}

export function admissionsOriginFromSearch(search: URLSearchParams): AdmissionsOrigin | null {
  const applicantId = search.get("applicant");
  const studentId = search.get("student");
  return search.get("origin") === "admissions" && applicantId?.trim() && studentId?.trim()
    ? { origin: "admissions", applicantId, studentId }
    : null;
}

export function applicantFileHref(origin: AdmissionsOrigin): string {
  return registrarApplicantPath(origin.applicantId);
}

export function admissionCourseSetupHref(studentId: string, applicantId: string | null): string {
  const search = new URLSearchParams({ student: studentId });
  if (applicantId) {
    search.set("origin", "admissions");
    search.set("applicant", applicantId);
  }
  return `${PROTECTED_ROUTES.admin.courses}?${search}`;
}
